import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'cpf-ui-kit',
  templateUrl: './ui-kit.component.html',
  styleUrls: ['./ui-kit.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class UiKitComponent {

}
